export const customStyles = {
    control: (base) => ({
        ...base,
        width: '17.7rem',
        borderColor: 'rgba(200, 0, 0, 1)',
        borderRadius: '4px',
        backgroundColor: 'rgba(248, 248, 248, 1)',
        // padding: '5px',
        fontSize: '16px',
        '&:hover': {
            borderColor: 'rgba(200, 0, 0, 1)',
            width: '17.7rem',
        },
        maxHeight: '150px',
        overflowY: 'auto',
    }),
    input: (base) => ({
        ...base,
        border: '0px solid black',
        outline: 'none',
        width: '20px',
        '&:focus': {
        border: '2px solid red !important',          // Apply !important here for focus state
        outline: 'none !important',         // Apply !important here for focus state
      },
    }),
    option: (base, state) => ({
        ...base,
        backgroundColor: state.isSelected ? '#005F73' : state.isFocused ? '#008CBA' : null,
        color: state.isSelected ? 'white' : 'black',
        padding: '10px',
        fontSize: '16px',
        '&:active': {
            backgroundColor: '#003B44',
        },
    }),
    menu: (base) => ({
        ...base,
        borderRadius: '8px',
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.1)',
    }),
    singleValue: (base) => ({
        ...base,
        color: '#333',
        fontWeight: '500',
    }),
    placeholder: (base) => ({
        ...base,
        color: '#888',
    }),
};